import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#1F2125",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M13.333 14.167 17.5 10m0 0-4.167-4.167M17.5 10h-10m2.5 4.167c0 .246 0 .37-.01.476a2.5 2.5 0 0 1-2.002 2.238c-.105.021-.228.035-.473.062l-.85.094c-1.28.143-1.919.213-2.427.051a2.5 2.5 0 0 1-1.52-1.36C2.5 15.24 2.5 14.596 2.5 13.31V6.69c0-1.287 0-1.93.218-2.417a2.5 2.5 0 0 1 1.52-1.36c.508-.163 1.147-.092 2.426.05l.851.094c.245.028.368.041.473.062A2.5 2.5 0 0 1 9.99 5.357c.009.107.009.23.009.476"
    }, null, -1)
  ]))]))
}
export default { render: render }